import { ReactNode } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableContainerProps,
  TableHead,
  TableRow,
} from "@mui/material";

interface IntegrationConfigurationsAndMessagesHalfDataTableProps {
  title: string;
  children: ReactNode;
  ContainerSxProps?: TableContainerProps["sx"];
}

export function IntegrationConfigurationsAndMessagesHalfDataTable({
  title,
  children,
  ContainerSxProps,
}: IntegrationConfigurationsAndMessagesHalfDataTableProps) {
  return (
    <TableContainer sx={ContainerSxProps}>
      <Table
        sx={{
          "tr:hover": {
            background: "inherit",
          },
        }}
      >
        <TableHead sx={{ backgroundColor: "inherit" }}>
          <TableRow
            sx={{
              "&:hover": {
                pointerEvents: "none",
                background: "inherit",
              },
            }}
          >
            <TableCell
              colSpan={2}
              sx={{
                pt: 0,
                pl: 0,
                pb: 1,
                borderBottom: (theme) =>
                  `1px solid ${theme.palette.background.lightest}`,
                textTransform: "uppercase",
              }}
            >
              {title}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
}
